import React from "react";
import Tooltip from "./../../Apps/common/Components/Tooltip/Tooltip";

const EstimatedQuantityTooltip = () => {
  return (
    <Tooltip
      title={`"Quantité estimée conformément à l'article 5.4.1.1.3.2 de l'ADR" si soumis`}
    />
  );
};

export default EstimatedQuantityTooltip;
